import { DateTime, DurationUnit } from 'luxon';

import { DurationUnitEnum } from '../../../shared/enums/duration-unit.enum';
import { toComputedPeriodDuration } from '../../../shared/functions/to-computed-period-duration.function';
import { toDuration } from '../../../shared/functions/to-duration.function';
import { RentalDurationPolicy } from '../consts/rental-duration.policy';
import { RentalDurationPolicyConfig } from '../interfaces/rental-duration-policy-config.interface';

/**
 * Billable duration value for quotation/search SP p_duration and extras.
 * DAY uses RentalDurationPolicy; other units use ceil via toComputedPeriodDuration.
 */
export function resolveBillableDurationValue(
  dateFrom: Date | DateTime | string | null | undefined,
  dateTo: Date | DateTime | string | null | undefined,
  durationUnit: DurationUnitEnum | DurationUnit | string | null | undefined,
  policyConfig: RentalDurationPolicyConfig | null,
): number | null {
  if (!dateFrom || !dateTo || !durationUnit) {
    return null;
  }

  const unitKey = durationUnit.toString().toLowerCase();

  if (unitKey === DurationUnitEnum.DAY || unitKey === 'days') {
    const durationBetween = toDuration(dateFrom, dateTo, {
      units: ['days'],
    });

    if (!durationBetween) {
      return null;
    }

    return (
      RentalDurationPolicy.apply(durationBetween, policyConfig).days ?? null
    );
  }

  const computed = toComputedPeriodDuration(dateFrom, dateTo, {
    units: [unitKey as DurationUnit],
  });

  const field = `${unitKey}s` as keyof NonNullable<typeof computed>;

  return computed?.[field] ?? null;
}
